import db from '@/store/db';
import log from '@/logger';

export default {
  getDefaultTodoTemplate: (projectId) => {
    return {
      projectId: projectId,
      title: 'New Template',
      type: 'TodoTemplate',
      archived: false,
      lastUpdate: {},
      todoTemplates: [],
    };
  },
  createTodoTemplate: function (projectId, newTodoTemplateProperties) {
    var newTodoTemplate = Object.assign({}, this.getDefaultTodoTemplate(projectId), newTodoTemplateProperties || {});

    return this.saveTodoTemplate(newTodoTemplate);
  },
  saveTodoTemplate: function (todoTemplate) {
    if (todoTemplate._id) {
      return db.currentProjectDb.put(todoTemplate).then((response) => {
        let updatedTodoTemplate = Object.assign({}, todoTemplate, { _rev: response.rev });
        return updatedTodoTemplate;
      });
    } else {
      return db.currentProjectDb.post(todoTemplate).then(function (doc) {
        todoTemplate._id = doc.id;
        todoTemplate._rev = doc.rev;
        return todoTemplate;
      });
    }
  },

  getTodoTemplates: function (projectId) {
    // We only want to edit templates in standard project
    return db.loadedDatabases[projectId]
      .query('todoTemplates', {
        include_docs: true,
        startkey: ['standard', ''],
        endkey: ['standard', '\ufff0'],
      })
      .then((result) => {
        let populated = [];
        for (var todoTemplate of result.rows) {
          todoTemplate = Object.assign(this.getDefaultTodoTemplate(projectId), todoTemplate.doc);
          populated.push(todoTemplate);
        }
        return populated;
      })
      .catch(function (err) {
        log.error('Unable to load todoTemplates', err);
        throw err;
      });
  },

  getTodoTemplate: async function (id) {
    if (!db.currentProjectDb.get) {
      return;
    }
    return db.currentProjectDb.get(id);
  },
};



// WEBPACK FOOTER //
// ./src/store/todoItem/todoTemplateApi.js